import {
  SUPPORT_PHONE_DISPLAY,
  SUPPORT_PHONE_TEL,
} from '../data/contact';

function HelpPage() {
  const supportEmail = 'GetSkimp@gmail.com';

  const recentArticles = [
    {
      title: 'Renters insurance 101 for Texas college students',
      excerpt:
        'A plain English guide that walks you through what renters insurance actually does, with examples tailored to Texas campuses.',
      meta: 'Coming soon · renters insurance basics',
    },
    {
      title: 'First time renter checklist before you move into your new place',
      excerpt:
        'A printable checklist to help you feel prepared on move in day, including when to line up coverage and what details to have ready.',
      meta: 'Coming soon · moving & setup',
    },
    {
      title: 'How much renters insurance do I really need as a student?',
      excerpt:
        'How to think about coverage limits, deductibles, and liability if you are renting your first apartment or dorm room.',
      meta: 'Coming soon · coverage limits',
    },
  ];

  return (
    <div className="container">
      <div style={{ marginBottom: '2rem' }}>
        <h2>Support Center</h2>
        <p style={{ marginTop: '0.5rem' }}>
          Need a hand getting started, stuck on a form, or just want a human to walk you through renters insurance?
          You&apos;re in the right place.
        </p>
      </div>

      <div
        className="card mb-4"
        style={{
          padding: '2rem',
          boxShadow: 'var(--shadow-lg)',
          borderColor: 'var(--color-green-light)',
          marginBottom: '2.5rem',
        }}
      >
        <div className="card-header" style={{ fontSize: '1.5rem', marginBottom: '0.75rem' }}>
          Talk to an agent
        </div>
        <div className="card-body">
          <p style={{ marginBottom: '1.25rem', fontSize: '1rem' }}>
            Get one on one help from a licensed insurance agent. We can answer questions about insurance,
            explain your options in plain English, and guide you through your application.
          </p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem', alignItems: 'center' }}>
            <a href={SUPPORT_PHONE_TEL} className="btn btn-lg btn-primary">
              Call {SUPPORT_PHONE_DISPLAY}
            </a>
            <a
              href={`mailto:${supportEmail}?subject=Support%20request%20from%20GetSkimp%20website`}
              className="btn btn-lg btn-outline"
            >
              Email an agent for support
            </a>
          </div>
          <p className="mt-2" style={{ fontSize: '0.9rem', color: '#6B7280' }}>
            Phone support available 8:00 AM–8:00 PM Central Time. Emails typically get a reply within
            one business day.
          </p>
        </div>
      </div>

      <div className="card mb-4">
        <div className="card-header">Visit the self help library</div>
        <div className="card-body">
          <p style={{ marginBottom: '1rem' }}>
            Prefer to read or explore on your own first? Our self help library has articles and checklists to walk you
            through common renters insurance questions.
          </p>
          <a href="/knowledge-base" className="btn btn-outline">
            Go to self help library
          </a>
        </div>
      </div>

      <div className="card">
        <div className="card-header">Latest articles &amp; guides</div>
        <div className="card-body">
          <p className="mb-2">
            We&apos;ll keep this section updated with our newest renters insurance tips, student guides, and important
            updates.
          </p>
          <div className="grid grid-3 mt-2">
            {recentArticles.slice(0, 2).map((article) => (
              <article
                key={article.title}
                className="card"
                style={{
                  boxShadow: 'none',
                  borderColor: 'var(--color-grey)',
                  margin: 0,
                  padding: '1rem 1.25rem',
                }}
              >
                <h4 style={{ marginBottom: '0.35rem' }}>{article.title}</h4>
                <p style={{ fontSize: '0.9rem', marginBottom: '0.5rem' }}>{article.excerpt}</p>
                <div style={{ fontSize: '0.8rem', color: '#6B7280', marginBottom: '0.75rem' }}>{article.meta}</div>
                <button
                  type="button"
                  className="btn btn-sm btn-outline"
                  style={{ cursor: 'default' }}
                  aria-label="Article coming soon"
                >
                  Coming soon
                </button>
              </article>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default HelpPage;


